<div class="marv_field"
     [class.inline]="this.inline">
    <div class="marv_field_label">
        @if(this.iconField){
            <ion-icon [name]="this.iconField"></ion-icon>
        }
        {{this.labelField}}
    </div>
    @if(this.valueField){
        <div class="marv_field_value">{{this.valueField}}</div>
    }
    <ng-content></ng-content>
</div>